import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fileSize',
  standalone: true
})
export class FileSizePipe implements PipeTransform {
  transform(size: number): string {
    const kiloByte = 1024;
    const megaByte = kiloByte * kiloByte;

    if (size === null || size === undefined) {
      return '';
    }

    if (size < kiloByte) {
      return '1 KB';
    }

    return size < megaByte ? Math.floor(size / kiloByte) + ' KB' : Math.floor(size / megaByte) + ' MB';
  }
}
